import React, { useState } from "react";
import { RCCHookToast, RCCServicesApi } from "react-common-components";
import Accordion from "src/components/Accordion";
import Loader from "src/components/Loader";
import Photo from "src/components/Photo";
import Title from "src/components/Title";
import { useTranslation } from "src/context/Translations/context";
import { standardErrorMessages } from "src/utils/errors";
import formatDate from "src/utils/formatDate";
import IGroupersOKR, { IGrouperOfOKRs, IListOKRs } from "./interface";
import ListOfOkrs from "./listOfOKRs";


const GrouperOfOkrs: React.FC<IGrouperOfOKRs> = ({
	grouper,
	layoutList,
	onViewHierarchy,
	openModalAddOrChange,
	openModalDelete,
	openModalOKRAttachments,
	openModalOKRComments,
	filters,
	groupersSelect
}) => {
	const {translate} = useTranslation();
	const { addToast } = RCCHookToast();
	const { REACT_APP_S3_ADDRESS, REACT_APP_S3_DIRECTORY } = process.env;

	const [list, setList] = useState<IListOKRs[]>([]);
	const [grouperData, setGrouperData] = useState<IGroupersOKR>(grouper);
	const [loading, setLoading] = useState(true);

	const handleClickGroupers = async (_e: any, expanded: boolean, grouperId: number, grouperTitle: string) => {
		if(!expanded)
			return;

		try{
			const {data} = await RCCServicesApi.getRequest({
				method: "OKR/List",
				urlParameters: {
					...groupersSelect,
					grouperId: groupersSelect.group === "5" ? grouperTitle : grouperId.toString(),
					f: filters.f || "",
					responsible: filters.responsible || "",
					authority: filters.authority || "",
					sector: filters.sector || "",
					tags: filters.tags || "",
					startDate: filters.startDate ? formatDate(filters.startDate) : "",
					endDate: filters.endDate ? formatDate(filters.endDate) : "",
					level: filters.level || "",
					okrId: filters.okrId || ""
				}
			});
			const listOkrs = data as IListOKRs[];
			setList(listOkrs);
			setLoading(false);
	
		}catch(err){
			standardErrorMessages(err, translate("Erro ao carregar os OKRs"), addToast);
		}

	};

	const callbackOnUpdate = async (id: number) => {
		try{
			const {data} = await RCCServicesApi.getRequest({
				method: "OKR/InfosOfOKRForList",
				urlParameters: {
					id
				}
			});
			const okr = data as IListOKRs;
			setList((prevState) => prevState.map((glist) => {
				if(glist.oka001Id === id)
					return okr;
				return glist;
			}));
		}catch(err){
			standardErrorMessages(err, translate("Erro ao atualizar OKR, favor atualizar a pagina"), addToast);
		}
	};

	const callbackOnDelete = (id: number) => {
		setGrouperData((prevState) => ({
			...prevState,
			count: prevState.count - 1
		}));
		setList((prevState) => prevState.filter((glist) => glist.oka001Id !== id));
	};

	return (
		<Accordion 
			key={`${grouperData.id}-grouper`}
			header={
				<div style={{display: "flex", justifyContent: "space-between"}}>
					<span style={{ display: "flex", alignItems: "center"}}>
						{grouperData.image !== null && (
							<Photo 
								hover
								name={grouperData.title}
								link={grouperData.image !== "" ? `${REACT_APP_S3_ADDRESS}/${REACT_APP_S3_DIRECTORY}/imagens_usuarios/${grouperData.image}` : ""}
							/>
						)}
						{grouperData.title}
					</span>
					<Title color="purple" size="sm">{translate("Total")}: {grouperData.count}</Title>
				</div>
			}
			onChange={(e, expanded) => handleClickGroupers(e, expanded, grouperData.id, grouperData.title)}
		>
			{loading ? (
				<Loader />
			): (
				<ListOfOkrs 
					data={list}
					layoutList={layoutList}
					openModalAddOrChange={openModalAddOrChange}
					openModalDelete={openModalDelete}
					openModalOKRComments={openModalOKRComments}
					openModalOKRAttachments={openModalOKRAttachments}
					callbackOnDelete={callbackOnDelete}
					callbackOnUpdate={callbackOnUpdate}
					onViewHierarchy={onViewHierarchy}
				/>
			)}
		</Accordion>
	);
};

export default GrouperOfOkrs;
